/* Tier Pricing Utilities - shared across variant-picker and size-inputs
 * Exposes window.TierPricing with:
 * - formatMoney(cents)
 * - updateTierPricingContainer(container, baseCents)
 */
(function () {
  if (!window) return;
  const formatMoney = (cents) => {
    const settings = (window.theme && theme.settings) || {};
    const template = settings.moneyFormat || settings.moneyWithCurrencyFormat || '£{{amount}}';
    let out = template.replace(/\{\{\s*(\w+)\s*}}/, (cents / 100).toFixed(2));
    // If falling back to moneyWithCurrencyFormat, strip any trailing currency code like " GBP"
    if (!settings.moneyFormat && settings.moneyWithCurrencyFormat) {
      out = out.replace(/\s*[A-Z]{3}\s*$/, '');
    }
    return out;
  };

  const updateTierPricingContainer = (container, baseCents) => {
    if (!container || typeof baseCents !== 'number') return;

    const unitPriceNodes = container.querySelectorAll('.col.tier-unit-price [data-discount]');
    if (!unitPriceNodes.length) return;

    unitPriceNodes.forEach((node) => {
      const discount = parseFloat(node.getAttribute('data-discount'));
      if (isNaN(discount)) {
        node.textContent = formatMoney(baseCents);
        return;
      }
      // Business rule: round up to the next cent to avoid under-charging
      node.textContent = formatMoney(Math.max(0, Math.ceil(baseCents * (1 - discount / 100))));
    });
  };

  window.TierPricing = window.TierPricing || {
    formatMoney,
    updateTierPricingContainer,
  };
})();
